import { flatten, get } from 'lodash'

import { isValidEmail, regExp } from '@sigma-frontend-libs/commons'
import { SENDING_PAYLOADS } from '@sigma-legacy-libs/essentials/lib/constants'
import { isPhoneNumber } from '@sigma-legacy-libs/essentials/lib/validators'
import { SendingTypes } from '@sigmasms/shared-types'

export * from '@sigma-legacy-libs/essentials/lib/validators'

export const isEmpty = value => {
  return [ undefined, null, '' ].includes(value)
}

export const isString = value => {
  return typeof value === 'string'
}
export const isStringNotEmpty = value => {
  return isString(value) && !isEmpty(value)
}

export const isArray = value => {
  return Array.isArray(value)
}
export const isArrayEmpty = value => {
  return isArray(value) && value.length === 0
}
export const isArrayNotEmpty = value => {
  return isArray(value) && value.length > 0
}

export const isObject = value => {
  return typeof value === 'object'
}
export const isObjectEmpty = value => {
  return isObject(value) && !isEmpty(value) && Object.keys(value).length === 0
}
export const isObjectNotEmpty = value => {
  return isObject(value) && !isEmpty(value) && Object.keys(value).length > 0
}

export const isPlainObject = value => {
  if (isObjectNotEmpty(value)) {
    if (typeof Object.getPrototypeOf === 'function') {
      const proto = Object.getPrototypeOf(value)

      return proto === Object.prototype || proto === null
    }

    return Object.prototype.toString.call(value) === '[object Object]'
  }

  return false
}

export const isValidPhone = (value = '') => {
  const { isValid } = isPhoneNumber(value)

  return Boolean(isValid)
}
export const isValidUserName = (value = '', regex = regExp.username) => {
  return regex.test(value) || isValidEmail(value)
}

export const isValidDate = value => {
  return value instanceof Date && !isNaN(value)
}

export const isHEX = (value = '') => {
  return /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(value)
}

export const isChildOf = (element, potentialParent) => {
  if (potentialParent.contains) {
    return potentialParent.contains(element)
  }

  let target = element
  while (target != null) {
    if (target === potentialParent) {
      return true
    }
    target = target.parentNode
  }

  return false
}

export const checkPermissions = (params, logic = null, accept = null, permissions = {}) => {
  if (logic && !~[ 'and', 'or' ].indexOf(logic)) {
    accept = logic
    logic = null
  }

  const result = {
    permissions: [],
    logic: 'or'
  }

  if (isStringNotEmpty(params)) {
    result.permissions = [
      {
        permission: params,
        accept: accept || true
      }
    ]
    result.logic = logic || result.logic
  }

  if (isArrayNotEmpty(params)) {
    result.permissions = params.map(item => {
      return {
        permission: item.permission || item,
        accept: item.accept || accept || true
      }
    })
    result.logic = 'or'
  }

  let comparisonMethod = 'some'
  if (result.logic === 'and') {
    comparisonMethod = 'every'
  }

  return result.permissions[comparisonMethod](item => {
    const flattenAccept = flatten([ item.accept ])
    const permissionValue = get(permissions, item.permission, false)

    return flattenAccept.includes(permissionValue)
  })
}

export const sendingPayloadValidator = (type, payload = {}) => {
  if (!type || !payload) {
    return false
  }

  if (!~Object.keys(SENDING_PAYLOADS).indexOf(type)) {
    return false
  }

  for (const key of [ 'sender', 'text' ]) {
    if (type === SendingTypes.voice) {
      continue
    }
    if (isEmpty(payload[key])) {
      return false
    }
  }

  switch (type) {
    case SendingTypes.viber: {
      if (!isEmpty(payload.image)) {
        if (payload.button) {
          if (isEmpty(payload.button.text) || !isEmpty(payload.button.text) && payload.button.text.length > 30) {
            return false
          }
          if (isEmpty(payload.button.url) || !isEmpty(payload.button.url) && payload.button.url.length > 2048) {
            return false
          }
        }
      }
      break
    }
    case SendingTypes.voice: {
      if (isEmpty(payload.sender)) {
        return false
      }
      if (isEmpty(payload.text)) {
        if (isEmpty(payload.audio)) {
          return false
        }
      } else {
        if (isEmpty(payload.tts)) {
          return false
        }
      }
      break
    }
  }

  return true
}
